import { createRoot } from 'react-dom/client';
import { StrictMode } from 'react';
import App from './App';

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element not found');

if (process.env.NODE_ENV === 'production') {
  console.log = () => {}
  console.error = () => {}
  console.debug = () => {}
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>
);